import cogoToast from 'cogo-toast';
import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import { uaeProjectsBaseURL, umsUrl } from '../../../../Containers/Config/index.js';
import { CREATE_ADIB_CLIENT, CREATE_ADIB_CLIENT_SUCCESS, CREATE_ADIB_CLIENT_ERROR } from './../../actionType.js';

function* createAdibClient({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v1/register`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        'Project-Code': 'ADMIN_ACCESS',
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      // cogoToast.success(response?.data?.message);
      if (localStorage.getItem('bankCode')) {
        localStorage.setItem('landmarkAuthToken', response?.headers?.authorization);
      }
      yield put({
        type: CREATE_ADIB_CLIENT_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CREATE_ADIB_CLIENT_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_ADIB_CLIENT_ERROR, payload: error });
  }
}

export function* watchCreateUser() {
  yield takeEvery(CREATE_ADIB_CLIENT, createAdibClient);
}

function* createAdibClientSaga() {
  yield all([fork(watchCreateUser)]);
}

export default createAdibClientSaga;
